import React, { useEffect } from "react"
import { FaRegCircleCheck } from "react-icons/fa6"
import { useTranslation } from "react-i18next"

import classes from "./CdsSuccessPage.module.scss"

const CdsSuccessPage = (props) => {
  const {
    successMessage,
    setShowSuccessPage
  } = props

  const [t] = useTranslation()

  useEffect(() => {
    const timeout =
      setTimeout(() => {
        setShowSuccessPage(false)
      }, 5000)

    return () => { clearTimeout(timeout) }
  }, [])

  return (
    <div className={classes["container"]}>
      <FaRegCircleCheck
        color="var(--color-success)"
        size={100}
      />

      <div className={classes["message"]}>
        {successMessage}
      </div>

      <div className={classes["message"]}>
        {t("ممنون_از_خرید_شما")}
      </div>
    </div>
  )
}

export default CdsSuccessPage